/**
 * UX 第3周 C（画面）の共通の文言: やること・次の1件・通知の文（messageKey + params）・
 * 欄ごとのエラー（fields[].code）・業務エラーのコード（errc.*）・カレンダー・時点の扱い。
 * i18n.ts が合成する。ほかの i18n/*.ts にあるキーはここで上書きしない（合成の順に頼らない）。
 */
export const ja: Record<string, string> = {
  "errc.SCHEMA_AT_APPLY": "承認された内容が台帳の今の決まりに合わないため、記録できませんでした",
  "errc.SCHEMA_AT_APPLY.body": "台帳には何も書かれていません。下の列を直すよう申請者に差し戻すか、台帳の担当者に相談してください。",
  "fld.REQUIRED": "入力してください",
  "fld.INVALID_CHOICE": "選択肢から選んでください",
  "fld.INVALID_TYPE": "形式が違います",
  "fld.INVALID_FORMAT": "形式が違います",
  "fld.TOO_SHORT": "{min}文字以上にしてください",
  "fld.TOO_LONG": "{max}文字以内にしてください",
  "fld.TOO_SMALL": "{min}以上にしてください",
  "fld.TOO_LARGE": "{max}以下にしてください",
  "fld.TOO_FEW": "{min}個以上にしてください",
  "fld.UNKNOWN_FIELD": "この項目は使えません",
  "fld.DUPLICATE": "同じものが既にあります",
  "fld.INVALID": "内容を確かめてください",
  "fld.TOTP_INVALID": "コードが違います。認証アプリに今出ている6桁を入れ直してください",
  "fld.PASSWORD_TOO_SHORT": "{min}文字以上にしてください",
  "fld.PASSWORD_NEEDS_UPPER": "英大文字を1つ以上入れてください",
  "fld.PASSWORD_NEEDS_LOWER": "英小文字を1つ以上入れてください",
  "fld.PASSWORD_NEEDS_DIGIT": "数字を1つ以上入れてください",
  "fld.WRONG_CURRENT": "今のパスワードが違います",
  "fld.SAME_AS_CURRENT": "今と違うパスワードにしてください",
  "fld.SINGLE_CHOICE_HAS_MULTIPLE_ANSWERS": "1つだけ選ぶ問題に、正解が2つ以上あります",
  "err.fieldsTitle": "{n} か所を直してください",
  "errc.VERSION_CONFLICT": "{name}さんが {time} にこの行を更新しました",
  "errc.VERSION_CONFLICT.anon": "ほかの人が先にこの行を更新しました",
  "errc.STALE": "承認の後に台帳が変わったため、記録できませんでした",
  "errc.ALREADY_DECIDED": "このステップは既に判断されています",
  "errc.BAD_STATE": "今の状態ではこの操作はできません",
  "errc.IDEMPOTENCY_SECRET_NOT_REPLAYED": "URL をもう一度表示することはできません",
  "cal.title": "カレンダーに登録",
  "nav.companySecurity": "会社のセキュリティ体制を見る",
};

export const en: Record<string, string> = {
  "errc.SCHEMA_AT_APPLY": "The approved content does not match the register’s current rules, so it could not be recorded",
  "errc.SCHEMA_AT_APPLY.body": "Nothing was recorded. Send the request back to the applicant to fix these columns, or ask the register owner.",
  "fld.REQUIRED": "Enter a value",
  "fld.INVALID_CHOICE": "Choose one of the options",
  "fld.INVALID_TYPE": "The format is not right",
  "fld.INVALID_FORMAT": "The format is not right",
  "fld.TOO_SHORT": "Use at least {min} characters",
  "fld.TOO_LONG": "Use {max} characters or fewer",
  "fld.TOO_SMALL": "Enter {min} or more",
  "fld.TOO_LARGE": "Enter {max} or less",
  "fld.TOO_FEW": "Add at least {min}",
  "fld.UNKNOWN_FIELD": "This field cannot be used",
  "fld.DUPLICATE": "This already exists",
  "fld.INVALID": "Check this value",
  "fld.TOTP_INVALID": "Wrong code. Enter the 6 digits your authenticator app shows now",
  "fld.PASSWORD_TOO_SHORT": "Use at least {min} characters",
  "fld.PASSWORD_NEEDS_UPPER": "Include at least one capital letter",
  "fld.PASSWORD_NEEDS_LOWER": "Include at least one lowercase letter",
  "fld.PASSWORD_NEEDS_DIGIT": "Include at least one number",
  "fld.WRONG_CURRENT": "The current password is wrong",
  "fld.SAME_AS_CURRENT": "Choose a password different from the current one",
  "fld.SINGLE_CHOICE_HAS_MULTIPLE_ANSWERS": "A single-answer question has more than one correct choice",
  "err.fieldsTitle": "Fix {n} field(s)",
  "errc.VERSION_CONFLICT": "{name} updated this row at {time}",
  "errc.VERSION_CONFLICT.anon": "Someone else updated this row first",
  "errc.STALE": "The register changed after approval, so the work could not be recorded",
  "errc.ALREADY_DECIDED": "This step has already been decided",
  "errc.BAD_STATE": "This action is not possible in the current state",
  "errc.IDEMPOTENCY_SECRET_NOT_REPLAYED": "The URL cannot be shown again",
  "cal.title": "Add to your calendar",
  "nav.companySecurity": "Company security setup",
};
